import React from 'react';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './FooterSection.scss';

interface FooterSectionProps {
  progress: number;
  productsCount: number;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ progress, productsCount }) => {
  const { t } = useTranslation();

  if (progress >= 100) {
    return null;
  }

  return (
    <Box marginTop={3} align="center" direction="vertical" gap={2}>
      <Text className={s.subtitle}>{t('PLEASE_WAIT_WHILE_WE_SET_UP_YOUR_STORE')}</Text>
      <Text className={s.subtitle}>{`Selected ${productsCount} premium products`}</Text>
    </Box>
  );
};
